import styled from "styled-components";

export const ContainerPorAtividade = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    /* CENTRALIZA O ESTADO VAZIO (NENHUMA ATIVIDADE SELECIONADA / SEM RESULTADO) */
    > div.ant-empty {
        margin: auto;
    }

    div.PorAtividade__list {
        width: 100%;
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        padding-right: 15px;

        button.PorAtividade__list__item {
            width: 100%;
            text-align: left;
            border-radius: 5px;
            border: none;
            background: transparent;
            box-sizing: border-box;
            padding: 5px 3px;
            transition: background 0.3s;
            cursor: pointer;

            :hover {
                background: rgba(139, 208, 107, 0.08);
            }

            :disabled {
                cursor: default;

                :hover {
                    background: transparent;
                }
            }

            div.PorAtividade__list__item__head {
                width: 100%;
                display: flex;
                align-items: baseline;
                justify-content: space-between;
                gap: 10px;

                span.PorAtividade__list__item__head__name {
                    display: flex;
                    align-items: baseline;
                    gap: 6px;
                    min-width: 0;
                    font-weight: 500;
                    font-size: 12px;
                    text-transform: capitalize;
                    color: var(--text-color);
                    white-space: nowrap;

                    /* TALHÕES DE PROPRIEDADES DIFERENTES PODEM TER O MESMO NOME,
                       ENTÃO A PROPRIEDADE É EXIBIDA PARA DIFERENCIAR.
                       O NOME DO TALHÃO TEM PRIORIDADE: A PROPRIEDADE CEDE ESPAÇO PRIMEIRO */
                    small.PorAtividade__list__item__head__name__propriedade {
                        flex: 1;
                        min-width: 0;
                        font-size: 10px;
                        font-weight: 500;
                        color: var(--text-color-light);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                span.PorAtividade__list__item__head__area {
                    flex-shrink: 0;
                    font-size: 11px;
                    font-weight: 500;
                    color: var(--text-color-light);
                }
            }

            div.PorAtividade__list__item__bar {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 7px;
                margin-top: 3px;

                div.PorAtividade__list__item__bar__track {
                    width: 100%;
                    height: 7px;
                    border-radius: 5px;
                    background: #FAFAFA;
                    overflow: hidden;

                    div.PorAtividade__list__item__bar__track__progress {
                        height: 100%;
                        border-radius: 5px;
                    }
                }

                span.PorAtividade__list__item__bar__percent {
                    flex-shrink: 0;
                    min-width: 34px;
                    text-align: right;
                    font-size: 11px;
                    font-weight: 600;
                    color: var(--text-color);
                }
            }
        }
    }

    div.PorAtividade__footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        box-sizing: border-box;
        padding-top: 8px;
        margin-top: 4px;
        border-top: thin solid var(--border-color);

        span.PorAtividade__footer__resumo {
            font-size: 11px;
            color: var(--text-color-light);
        }

        span.PorAtividade__footer__total {
            font-size: 11px;
            font-weight: 600;
            color: var(--text-color);

            b.PorAtividade__footer__total__valor {
                font-weight: 700;
            }
        }
    }
`;
